import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Card, { DefaultCardHeader, DefaultCardBody } from './'
import { CardItem } from './StyledCard'
import { ReactComponent as Delete } from '../shared/icons/delete.svg'
import Add from '../shared/icons/Add'

const CardItemList = ({ items = [], onAddItem, onRemoveItem, onRemoveAll, ItemComponent, ...props }) => {
	const BodyComponent = useCallback(({ style, ...bodyProps }) => <DefaultCardBody {...bodyProps} style={{ ...style, padding: '0' }}/>, [])
	const HeaderComponent = useCallback(({ children, ...headerProps }) => (
		<DefaultCardHeader {...headerProps}>
			{children}
			<div>
				{onRemoveAll && <Delete onClick={() => onRemoveAll()} className='header-delete' />}
				{onAddItem && <Add onClick={onAddItem} />}
			</div>
		</DefaultCardHeader>
	), [onAddItem])
	return (
		<Card {...props} BodyComponent={BodyComponent} HeaderComponent={HeaderComponent}>
			{items.map((item, i) => (
				<CardItem key={i}>
					<ItemComponent item={item}/>
					{onRemoveItem && <Delete onClick={() => onRemoveItem(item)}/>}
				</CardItem>
			))}
		</Card>
	)
}

CardItemList.propTypes = {
	onAddItem: PropTypes.func,
	onRemoveItem: PropTypes.func,
	onRemoveAll: PropTypes.func,
	ItemComponent: PropTypes.PropTypes.oneOfType([ PropTypes.element, PropTypes.func ])
}

CardItemList.defaultProps = {
	ItemComponent: ({ name }) => name || null
}

export default CardItemList
